import { useState } from "react";
import { login } from "../services/api";
import logo from "../assets/logo.png";
import logoDark from "../assets/logo-dark.png";

export default function Login({ onSuccess, theme, onToggleTheme }) {
  const [kullaniciAdi, setKullaniciAdi] = useState("");
  const [sifre, setSifre] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!kullaniciAdi.trim() || !sifre) return;
    setLoading(true);
    setError(null);
    try {
      const r = await login(kullaniciAdi.trim(), sifre);
      onSuccess(r.data);
    } catch (e2) {
      setError(e2.response?.data?.detail || e2.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", background: "var(--bg-page)" }}>
      <button
        onClick={onToggleTheme}
        title={theme === "dark" ? "Aydınlık moda geç" : "Karanlık moda geç"}
        style={{
          position: "absolute", top: 20, right: 20,
          display: "flex", alignItems: "center", gap: 8,
          padding: "8px 14px", borderRadius: 8, border: "1px solid var(--border)",
          background: "var(--bg-card)", color: "var(--text-secondary)", cursor: "pointer", fontSize: 13,
        }}
      >
        <span>{theme === "dark" ? "🌙" : "☀️"}</span>
        <span>{theme === "dark" ? "Karanlık Mod" : "Aydınlık Mod"}</span>
      </button>

      <form
        onSubmit={handleSubmit}
        style={{ width: 380, background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 14, padding: "40px 32px", boxShadow: "0 25px 50px rgba(0,0,0,0.35)" }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 36 }}>
          <img
            src={theme === "dark" ? logoDark : logo}
            alt="EMK Yazılım"
            style={{ height: 64, width: "auto", display: "block" }}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, color: "var(--text-muted)", fontWeight: 600, marginBottom: 6, textTransform: "uppercase" }}>Kullanıcı Adı</div>
          <input
            autoFocus
            value={kullaniciAdi}
            onChange={(e) => setKullaniciAdi(e.target.value)}
            style={{ width: "100%", background: "var(--bg-page)", border: "1px solid var(--border)", borderRadius: 7, padding: "11px 14px", color: "var(--text-primary)", fontSize: 14, outline: "none", boxSizing: "border-box" }}
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 11, color: "var(--text-muted)", fontWeight: 600, marginBottom: 6, textTransform: "uppercase" }}>Şifre</div>
          <input
            type="password"
            value={sifre}
            onChange={(e) => setSifre(e.target.value)}
            style={{ width: "100%", background: "var(--bg-page)", border: "1px solid var(--border)", borderRadius: 7, padding: "11px 14px", color: "var(--text-primary)", fontSize: 14, outline: "none", boxSizing: "border-box" }}
          />
        </div>

        {error && (
          <div style={{ background: "#450a0a", border: "1px solid #7f1d1d", borderRadius: 7, padding: "9px 12px", color: "#fca5a5", fontSize: 13, marginBottom: 18 }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading || !kullaniciAdi.trim() || !sifre}
          style={{
            width: "100%", padding: "12px 0", borderRadius: 8, border: "none",
            background: loading || !kullaniciAdi.trim() || !sifre ? "var(--border)" : "#1d4ed8",
            color: loading || !kullaniciAdi.trim() || !sifre ? "var(--text-muted)" : "#fff",
            fontSize: 14, fontWeight: 600, cursor: loading || !kullaniciAdi.trim() || !sifre ? "not-allowed" : "pointer",
          }}
        >
          {loading ? "⏳ Giriş yapılıyor..." : "Giriş Yap"}
        </button>
      </form>

      <div style={{ position: "absolute", bottom: 20, fontSize: 12, color: "var(--text-faint)" }}>
        © 2026 EMK Yazılım Teknoloji. Tüm Hakları Saklıdır.
      </div>
    </div>
  );
}
